export default function Hero() {
    return (
        <>
            <span className="hero__eyebrow">⚽️ You're Invited</span>
            <h1 className="hero__title">
                FIFA World Cup <span>2026</span>
            </h1>
            <p className="hero__subtitle">
                Join for the ultimate group stage showdown -<br />
                live at BC Place, Vancouver
            </p>
        </>
    )
}